<template>
  <div class="admin-wrapper">
    <div v-if="!isAuthenticated || !isAdmin" class="login-section">
      <LoginForm @login-success="handleLoginSuccess" />
    </div>

    <div v-else class="admin-container">
      <nav class="admin-nav">
        <div class="nav-brand">
          <img src="@/assets/logotipo-short.webp" alt="Coppados">
          <span>Admin</span>
        </div>
        
        <div class="nav-user">
          <button @click="handleLogout" class="logout-btn">Salir</button>
        </div>
      </nav>

      <div class="admin-content">
        <div class="tabs">
          <button
            v-for="tab in tabs"
            :key="tab"
            @click="activeTab = tab"
            :class="{ active: activeTab === tab }"
            class="tab-button"
          >
            {{ tab }}
          </button>
        </div>

        <div class="tab-content">
          <CarouselAdmin v-if="activeTab === 'Carrousel'" />
          <DJsAdmin v-if="activeTab === 'DJs'" />
          <EventsAdmin v-if="activeTab === 'Eventos'" />
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { signOut, onAuthStateChanged } from 'firebase/auth'
import { auth } from '@/services/firebase'
import CarouselAdmin from '@/components/admin/CarouselAdmin.vue'
import DJsAdmin from '@/components/admin/DJsAdmin.vue'
import EventsAdmin from '@/components/admin/EventsAdmin.vue'
import LoginForm from '@/components/LoginForm.vue'

export default {
  name: 'AdminView',
  components: {
    CarouselAdmin,
    DJsAdmin,
    EventsAdmin,
    LoginForm
  },
  data() {
    return {
      activeTab: 'Carrousel',
      tabs: ['Carrousel', 'DJs', 'Eventos'],
      userEmail: '',
      isAuthenticated: false,
      isAdmin: false,
      adminEmail: process.env.VUE_APP_ADMIN_EMAIL
    }
  },
  mounted() {
    onAuthStateChanged(auth, (user) => {
      if (user) {
        this.userEmail = user.email
        this.isAuthenticated = true
        this.isAdmin = user.email === this.adminEmail
      } else {
        this.isAuthenticated = false
        this.isAdmin = false
      }
    })
  },
  methods: {
    handleLoginSuccess() {
      // El login fue exitoso, se actualizará automáticamente por el onAuthStateChanged
      this.isAuthenticated = true
    },
    async handleLogout() {
      try {
        await signOut(auth)
        this.isAuthenticated = false
        this.isAdmin = false
        this.userEmail = ''
      } catch (error) {
        console.error('Error al cerrar sesión:', error)
      }
    }
  }
}
</script>

<style scoped>
.admin-wrapper {
  width: 100%;
  min-height: 100vh;
  background: #f5f5f5;
  display: flex;
  flex-direction: column;
}

.login-section {
  display: flex;
  align-items: center;
  justify-content: center;
  width: 100%;
  min-height: 100vh;
  background: #f5f5f5;
}

.admin-container {
  display: flex;
  flex-direction: column;
  width: 100%;
  min-height: 100vh;
  background: #f5f5f5;
}

.admin-nav {
  background: white;
  border-bottom: 1px solid #e0e0e0;
  padding: 1rem 2rem;
  display: flex;
  justify-content: space-between;
  align-items: center;
  box-shadow: 0 2px 8px rgba(0, 0, 0, 0.08);
  flex-shrink: 0;
}

.nav-brand {
  display: flex;
  align-items: center;
  gap: 1rem;
  font-size: 1.5rem;
  font-weight: 700;
  color: black;
}

.nav-brand img {
  width: 40px;
  height: 40px;
  object-fit: contain;
}

.nav-user {
  display: flex;
  align-items: center;
  gap: 1.5rem;
  color: #666;
}

.logout-btn {
  padding: 0.6rem 1.2rem;
  background: #333;
  color: white;
  border: none;
  border-radius: 8px;
  cursor: pointer;
  font-size: 0.9rem;
  font-weight: 600;
  transition: all 0.3s ease;
}

.logout-btn:hover {
  background: #000;
  box-shadow: 0 4px 12px rgba(0, 0, 0, 0.15);
}

.admin-content {
  flex: 1;
  padding: 2rem;
  width: 100%;
  overflow-y: auto;
}

.tabs {
  display: flex;
  gap: 1rem;
  margin-bottom: 2rem;
  border-bottom: 2px solid #e0e0e0;
}

.tab-button {
  padding: 1rem 1.5rem;
  background: none;
  border: none;
  border-bottom: 3px solid transparent;
  cursor: pointer;
  font-size: 1rem;
  font-weight: 600;
  color: #666;
  transition: all 0.3s ease;
  margin-bottom: -2px;
}

.tab-button:hover {
  color: #333;
}

.tab-button.active {
  color: black;
  border-bottom-color: black;
}

.tab-content {
  animation: fadeIn 0.3s ease;
}

@keyframes fadeIn {
  from {
    opacity: 0;
  }
  to {
    opacity: 1;
  }
}

@media (max-width: 768px) {
  .admin-nav {
    padding: 1rem;
    flex-direction: row;
    justify-content: space-between;
    align-items: center;
  }

  .admin-content {
    padding: 1rem;
  }

  .tabs {
    overflow-x: auto;
    padding-bottom: 0.5rem;
    margin-bottom: 1rem;
    gap: 0;
  }

  .tab-button {
    padding: 0.75rem 1rem;
    font-size: 0.9rem;
    white-space: nowrap;
    flex: 1;
    text-align: center;
  }

  .nav-brand {
    font-size: 1.2rem;
    gap: 0.5rem;
  }

  .nav-brand img {
    width: 35px;
    height: 35px;
  }

  .nav-user {
    gap: 1rem;
    font-size: 0.9rem;
  }

  .logout-btn {
    padding: 0.5rem 1rem;
    font-size: 0.9rem;
  }
}

@media (max-width: 480px) {
  .admin-nav {
    padding: 1rem;
    flex-direction: row;
    justify-content: space-between;
    align-items: center;
    gap: 0.5rem;
  }

  .nav-brand {
    font-size: 1rem;
    gap: 0.5rem;
    flex: 1;
  }

  .nav-brand img {
    width: 32px;
    height: 32px;
  }

  .nav-user {
    display: flex;
    align-items: center;
    justify-content: flex-end;
  }

  .logout-btn {
    padding: 0.5rem 1rem;
    font-size: 0.85rem;
    white-space: nowrap;
  }

  .admin-content {
    padding: 0.75rem;
  }

  .tabs {
    gap: 0;
    margin-bottom: 1rem;
    overflow-x: auto;
    -webkit-overflow-scrolling: touch;
  }

  .tab-button {
    padding: 0.7rem 1rem;
    font-size: 0.8rem;
    flex: 0 0 auto;
    min-width: auto;
    text-align: center;
  }
}
</style>
